import React from 'react';
import styled from 'styled-components';
import Button from './Button';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 40px;
  background: linear-gradient(135deg, #ffffff 0%, #FFF8F2 100%);
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 4px 12px rgba(210, 105, 30, 0.05);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const Title = styled.h1`
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  font-size: 26px;
  color: #D2691E;
  margin: 0;
  letter-spacing: -0.5px;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const SortLabel = styled.span`
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #6B6B6B;
`;

const PageHeader = ({ 
  title, 
  showAddButton = false, 
  addButtonText = "등록", 
  onAddClick,
  sortComponent,
  searchComponent 
}) => {
  return (
    <HeaderContainer>
      <HeaderLeft>
        <Title>{title}</Title>
      </HeaderLeft>
      
      <HeaderRight>
        {searchComponent}
        {sortComponent && (
          <>
            <SortLabel>정렬</SortLabel>
            {sortComponent}
          </>
        )}
        {showAddButton && (
          <Button 
            variant="primary" 
            size="large"
            onClick={onAddClick}
          >
            {addButtonText}
          </Button>
        )}
      </HeaderRight>
    </HeaderContainer>
  );
};

export default PageHeader;
